"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var Radio_1 = __importDefault(require("@mui/material/Radio"));
var react_1 = require("react");
var RadioIcon_1 = __importDefault(require("../../../Assets/CustomIcons/RadioIcon"));
var CardButton_1 = __importDefault(require("../../Atoms/CardButton/CardButton"));
var Text_1 = __importDefault(require("../../Atoms/Text"));
var RadioGroupContext_1 = __importDefault(require("../../Organisms/RadioGroup/RadioGroupContext"));
var TextField_1 = __importDefault(require("../TextField/TextField"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var browserAndDeviceDetection_1 = require("../../../Helpers/browserAndDeviceDetection");
var deviceSpecificHandlers_1 = require("../../../Helpers/deviceSpecificHandlers");
var makeRadioButtonStyling_1 = __importDefault(require("./makeRadioButtonStyling"));
var RadioButton = function (_a) {
    var Icon = _a.Icon, id = _a.id, text = _a.text, onBlur = _a.onBlur, onClick = _a.onClick, onChange = _a.onChange, onKeyDown = _a.onKeyDown, isOtherOption = _a.isOtherOption, otherInputError = _a.otherInputError, otherInputValue = _a.otherInputValue, experimentName = _a.experimentName, smallIcon = _a.smallIcon;
    var _b = (0, react_1.useContext)(RadioGroupContext_1.default), selectedId = _b.selectedId, setSelectedId = _b.setSelectedId;
    var _c = (0, react_1.useState)(otherInputValue), otherValue = _c[0], setOtherValue = _c[1];
    var _d = (0, react_1.useState)(false), isFocused = _d[0], setIsFocused = _d[1];
    var otherInputRef = (0, react_1.useRef)(null);
    var isSelected = id === selectedId;
    var styles = (0, makeRadioButtonStyling_1.default)(smallIcon);
    var isTextfield = (isOtherOption && isFocused) || !!otherValue;
    var isIconPresent = !!Icon;
    var handleClick = function () {
        onClick({ id: id });
        if ((0, browserAndDeviceDetection_1.isIOS)() && !otherInputRef.current && isOtherOption) {
            (0, deviceSpecificHandlers_1.iosFocusHandler)(otherInputRef);
        }
        if (otherInputRef.current) {
            otherInputRef.current.focus();
            if (!isSelected && otherValue) {
                setSelectedId(id);
            }
            return;
        }
        setSelectedId(id);
        setIsFocused(true);
    };
    var handleKeyDown = function (event) {
        if (event) {
            onKeyDown(event);
            if (event.key === 'Enter' && otherInputRef.current) {
                if (!otherValue) {
                    setSelectedId(undefined);
                    setIsFocused(false);
                }
                otherInputRef.current.blur();
            }
        }
    };
    var onOtherTextFieldChange = function (inputChangeEvent) {
        onChange(inputChangeEvent);
        setOtherValue(inputChangeEvent.value);
        if (inputChangeEvent.value) {
            setSelectedId(id);
        }
        else {
            setSelectedId(undefined);
        }
    };
    (0, react_1.useEffect)(function () {
        if (isSelected && otherInputRef.current && !(0, browserAndDeviceDetection_1.isIOS)()) {
            otherInputRef.current.focus();
        }
    }, [isSelected]);
    var handleBlur = function () {
        if (!otherValue) {
            setSelectedId(undefined);
        }
        setIsFocused(false);
    };
    return ((0, jsx_runtime_1.jsx)(Grid_1.default, { children: (0, jsx_runtime_1.jsx)(CardButton_1.default, __assign({ selected: isSelected, "data-selected": isSelected, onClick: handleClick, onKeyDown: handleKeyDown, onBlur: handleBlur, "data-testid": "radioButtonCardButton", outlined: isSelected, experimentName: experimentName }, { children: (0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ container: true, css: styles.grid, justifyContent: "flex-start", alignItems: "center", wrap: "nowrap" }, { children: (0, jsx_runtime_1.jsxs)(Grid_1.default, __assign({ container: true, alignItems: "center", css: styles.innerGrid }, { children: [isIconPresent ? ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true, css: styles.icon }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ css: styles.imgDiv, "data-testid": "radioIcon" }, { children: Icon })) }))) : ((0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(Radio_1.default, { id: "radio-".concat(id), icon: (0, jsx_runtime_1.jsx)(RadioIcon_1.default, { isChecked: false }), checkedIcon: (0, jsx_runtime_1.jsx)(RadioIcon_1.default, { isChecked: true }), css: styles.radio, checked: isSelected, 
                                // TODO there is no click handler on the radio button itself, add one so that the radio button can be selected by clicking on it
                                color: "primary", "data-testid": "toggle-".concat(id), onMouseDown: function (event) { return event.preventDefault(); } }) }))), (0, jsx_runtime_1.jsx)(Grid_1.default, __assign({ item: true, css: styles.textGrid }, { children: isTextfield ? ((0, jsx_runtime_1.jsx)("div", __assign({ css: styles.otherInput }, { children: (0, jsx_runtime_1.jsx)(TextField_1.default, { "data-testid": "otherOptionTextfield:".concat(id), id: id, placeholder: text, onBlur: onBlur, onChange: onOtherTextFieldChange, isOtherOption: true, inputRef: otherInputRef, errorMessage: otherInputError ? '' : undefined, value: otherInputValue, inputProps: {
                                        enterKeyHint: 'go',
                                    }, experimentName: experimentName }) }))) : ((0, jsx_runtime_1.jsx)(Text_1.default, __assign({ variant: "listItem", align: "left", experimentName: experimentName }, { children: text }))) }))] })) })) })) }));
};
RadioButton.defaultProps = defaultProps_1.default;
exports.default = RadioButton;
//# sourceMappingURL=RadioButton.js.map